export default {"src":"/_next/static/media/chart-bar-dark.c5cc8973.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};